import { render, staticRenderFns } from "./edit-description.vue?vue&type=template&id=1ad0594c&scoped=true&"
import script from "./edit-description.vue?vue&type=script&lang=js&"
export * from "./edit-description.vue?vue&type=script&lang=js&"
import style0 from "./edit-description.vue?vue&type=style&index=0&id=1ad0594c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0594c",
  null
  
)

export default component.exports